export const GERMAN_IBAN_REGEX = /^DE([0-9a-zA-Z]\s?){20}$/;
